/* THE LONGEVITY LAB — shared JS for custom sections */

// scroll reveal for .ll-reveal elements
(function () {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('ll-in'); });
  }, { threshold: 0.08 });
  document.querySelectorAll('.ll-reveal').forEach((el, i) => {
    el.style.transitionDelay = (i % 4 * 0.06) + 's';
    io.observe(el);
  });
})();
